(function() {
  angular.module('cfn').factory('UserSettings', UserSettings);

  UserSettings.$inject = ['$resource'];
  function UserSettings($resource) {
    return $resource(
      '/365FarmNet/rest/userSettings',
      {},
      {
        save: { method: 'PUT' }
      }
    );
  }
})();
